import React, { useState, useContext, useEffect } from "react";
import "./Product_Card.css";
import { Card, CardFooter } from "react-bootstrap";
import SupermarketModal from "../../Common_modal/Supermarket-modal/SupermarketModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCartShopping,
  faHeart,
  faShare,
  faShareNodes,
} from "@fortawesome/free-solid-svg-icons";

import { Context } from "../../../utils/context";
import { ShimmerPostItem } from "react-shimmer-effects";
import { useNavigate } from "react-router-dom";
import { AddToCart } from "../../../utils/apis/addToCart/addToCart";

import {
  addWishlist,
  getWishlist,
} from "../../../utils/apis/Wishlist/Wishlist";
import Loader_lottie from "../../Animation/Loader_lottie/Loader_lottie";
import { ShimmerThumbnail } from "react-shimmer-effects";

function Product_Card({
  product_id,
  price,
  subText,
  text,
  image,
  variant_id,
  m_variant_id,
  product,
  newest,
  cutprice,
  handleProductClick,
}) {
  const {
    shimmerLoader,
    setShimmerLoader,
    addCartModal,
    setAddCartModal,
    wishlistData,
    wishlistContext,
    triggerCartUpdate,
    setCartCount,
    setNoProductAvailable,
  } = useContext(Context);
  const navigate = useNavigate();
  const { signin } = useContext(Context);
  const handleHeartClick = async (data) => {
    if (signin) {
      const res = await addWishlist(data);
      if (res?.success) {
        await wishlistContext();
      }
    } else {
      await navigate("/login");
    }
  };

  const handleNavigate = () => {
    // prefer the prop handler if provided (it handles navigate + reload/scroll)
    if (typeof handleProductClick === "function") {
      handleProductClick(product_id);
      return;
    }
    // fallback to direct navigation
    navigate(`/vendor-page/${product_id}`);
  };

  // useEffect(() => {
  //   window.scrollTo({
  //     top: 0,
  //     behavior: "smooth",
  //   });
  // }, [product_id]);

  return (
    <>
      {shimmerLoader ? (
        // <div className="loader-container text-center my-5">
        //   <Loader_lottie />
        //   <p className="mt-2">Loading ...</p>
        // </div>

        <ShimmerThumbnail rounded />
      ) : (
        <div className="main-product-img-main mt-2 mb-2">
          <Card>
            <div className="main-product-main mx-auto">
              <Card.Img
                onClick={handleNavigate}
                variant="top"
                src={image}
                className="product-img"
                alt="..."
              />
            </div>
            <div className="Coupon-latest-holder">
              {newest == 1 ? (
                <div className="text-holder ">
                  <h3 className="font_Josefin">New</h3>
                </div>
              ) : (
                ""
              )}
            </div>
            <div className="Coupon-discount-holder"></div>
            {/* <div className="add-cart-sec">
              <div className="cart_icon_box" onClick={handleNavigate}>
                <p>
                  <FontAwesomeIcon
                    icon={faCartShopping}
                    className="cart-logo  "
                  />
                </p>
              </div>

              <div className="cart_icon_box">
                <p
                  onClick={async () =>
                    await handleHeartClick({
                      product_id: product_id,
                      variant_id: variant_id,
                      m_variant_id: m_variant_id,
                    })
                  }>
                  <FontAwesomeIcon
                    icon={faHeart}
                    className={
                      wishlistData?.some(
                        (item) => item.product_id == product_id
                      )
                        ? "cart-logo me-2 active"
                        : "cart-logo me-2"
                    }
                  />
                </p>
              </div>
            </div> */}
            <Card.Body>
              <Card.Text className=" text-holder  mt-1">
                <h4>{text}</h4>
                {/* <span>{subText}</span> */}
                <div className="price_holder">
                  <p className="card-second-line Discount_price">₹ {price}/-</p>
                  <p className="card-second-line MRP_price">₹ {cutprice}/-</p>
                </div>
              </Card.Text>
            </Card.Body>
          </Card>
        </div>
      )}
    </>
  );
}

export default Product_Card;
